import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '1.3rem',
    fontWeight: 'bold',
    color: theme.workwaveBlue,
    textAlign: 'center',
    lineHeight: '1',
    margin: '0 auto',
    position: 'absolute',
    padding: '0 5px',
    left: '50px',
    right: '0',
    fontFamily: 'Poppins, sans-serif',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.2rem',
    },
  },
  card: {
    boxShadow: '0 10px 40px 0px rgba(0,0,0,0.10)',
    borderRadius: '20px',
    cursor: 'pointer',
    background: theme.white,
    width: '100%',
    transition: 'transform 0.25s, box-shadow 0.75s',
    margin: '0 auto',
    position: 'relative',
    border: '2px solid #E5EAF4',
    userSelect: 'none',
    paddingRight: '30px',
    '&:last-of-type': {
      paddingRight: '0px',
    },
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  cardGrid: {
    marginBottom: '30px',
    paddingRight: '30px',
    '&:last-of-type': {
      paddingRight: '0px',
    },
  },
  cardMargin: {
    marginBottom: '26px',
  },
}));

export const BodyFeatureCard = ({
  featureHeader,
  featureSection,
  selectedFeature,
  handleClick,
  featureRef,
  featureListCta,
  setFeatureModalOpen,
  accentColor,
  persona,
  noOverview,
  api,
  partnerSectionScroll,
  franchises,
  heroVideo,
  noPaddingBottom, // New prop to control container bottom padding
}) => {
  const fourCards =
    featureSection.length === 4 || featureSection.length === 7 || api;
  const classes = useStyles();
  return featureSection.length > 2 ? (
    <div
      style={{
        padding: heroVideo
          ? `2rem 0 ${noPaddingBottom ? '0' : '4rem'} 0`
          : `0 0 ${noPaddingBottom ? '0' : '4rem'} 0`,
      }}
      ref={featureRef}
    >
      <Grid
        container
        direction='row'
        justifyContent='center'
        style={{ padding: '0 0 2rem 0' }}
      >
        <Typography
          variant='h2'
          style={{
            color: '#002D5C',
            fontWeight: 600,
            fontSize: '1.8rem',
          }}
        >
          {featureHeader}
        </Typography>
      </Grid>
      <Grid container direction='row' justifyContent='center'>
        {featureSection.map((content, index) => (
          <Grid
            style={{ padding: '0 14px' }}
            item
            container
            xs={12}
            md={fourCards ? 3 : 4}
            key={index}
            className={
              featureSection.length > 4 && index < 3
                ? classes.cardMargin
                : classes.cardGrid
            }
          >
            <div
              className={classes.card}
              style={
                selectedFeature === content._key
                  ? {
                      border: '2px solid #002D5C',
                      transition: 'transform 0.25s, box-shadow 0.75s',
                    }
                  : null
              }
            >
              <Grid
                onClick={(e) => handleClick(e, content)}
                container
                direction='row'
                justifyContent='flex-start'
                alignItems='center'
              >
                <FontAwesomeIcon
                  icon={['fad', content.specialFaIcon?.name ?? 'fish']}
                  style={{
                    height: '40px',
                    width: '40px',
                    padding: '6px',
                    borderRadius: '100%',
                    background: '#002D5C',
                    margin: '5px',
                    '--fa-primary-color': '#FFF',
                    '--fa-secondary-color':
                      content.specialFaIcon?.colors[1]?.color ?? '#0cff00',
                    '--fa-primary-opacity': 1,
                    '--fa-secondary-opacity': 1,
                  }}
                />
                <Typography className={classes.title}>
                  {content.cardTitle}
                </Typography>
              </Grid>
            </div>
          </Grid>
        ))}
        {api ? (
          <Grid
            style={{ padding: '0 14px' }}
            item
            container
            xs={12}
            md={3}
            className={
              featureSection.length > 4 ? classes.cardMargin : classes.cardGrid
            }
          >
            <div className={classes.card}>
              <Grid
                onClick={(e) => partnerSectionScroll(e)}
                container
                direction='row'
                justifyContent='flex-start'
                alignItems='center'
              >
                <FontAwesomeIcon
                  icon={['fad', 'handshake-simple']}
                  style={{
                    height: '50px',
                    width: '50px',
                    border: `1px solid #E5EAF4`,
                    background: '#E5EAF4',
                    padding: '6px',
                    color: '#002D5C',
                  }}
                />
                <Typography className={classes.title}>
                  API & Software Partners
                </Typography>
              </Grid>
            </div>
          </Grid>
        ) : null}
      </Grid>
      {featureListCta && (
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='center'
        >
          <Button
            variant='contained'
            size='small'
            onClick={(e) => setFeatureModalOpen(true)}
            style={{
              background: accentColor ?? '#002D5C',
              color: 'white',
              marginTop: '2rem',
            }}
          >
            {featureListCta}
          </Button>
        </Grid>
      )}
    </div>
  ) : null;
};
